// extracted by mini-css-extract-plugin
export default {"control":"playerNameInput_control__Qpa4A"};